export const UPDATE_BOOKING_EXPERIENCE_START = 'UPDATE_BOOKING_EXPERIENCE_START';

export const UPDATE_BOOKING_EXPERIENCE_SUCCESS = 'UPDATE_BOOKING_EXPERIENCE_SUCCESS';

export const UPDATE_BOOKING_EXPERIENCE_FAILED = 'UPDATE_BOOKING_EXPERIENCE_FAILED';
